export const landingpage_toggleAccordion = (event: Event) => {
    event.preventDefault()
    document.querySelectorAll("#landing-page-holder .lp-abouts").forEach(e => {
        const button = document.querySelector("#landing-page-holder .btn--abouts")
        if (e instanceof HTMLElement) {
            const open = !e.classList.contains("closed") && !e.classList.contains("hidden")
            const newIsOpen = !open
            if (newIsOpen) {
                e.classList.remove("closed")
                e.classList.remove("hidden")
                button?.setAttribute("aria-expanded", "true")
            } else {
                e.classList.add("closed")
                e.classList.add("hidden")
                button?.setAttribute("aria-expanded", "false")
            }
        }
    })
}